











































































import { Component, Vue } from 'vue-property-decorator';
import { User } from '@/interfaces/user.interface';
import { VALIDATION_RULES } from '@/helpers/helpers';
import { namespace } from 'vuex-class';

const usersModule = namespace('users');

@Component
export default class UserAdd extends Vue {
  @usersModule.Action createUser: any;
  @usersModule.Action closeAddUserDialog: any;
  @usersModule.Action openAddUserDialog: any;
  @usersModule.State addUserDialogVisible: any;

  user: User = {};
  valid = false;

  userEmailRules = [...VALIDATION_RULES.required, ...VALIDATION_RULES.email];
  userNameRules = [...VALIDATION_RULES.required];
  userPasswordRules = [...VALIDATION_RULES.required, ...VALIDATION_RULES.password];

  get dialog(): boolean {
    return this.addUserDialogVisible;
  }

  set dialog(value: boolean) {
    value && this.openAddUserDialog() || this.closeAddUserDialog();
  }

  closeDialog() {
    this.closeAddUserDialog();
  }

  handleSubmit() {
    this.createUser({
      user: this.user,
      successAction: 'closeAddUserDialog'
    });
  }
}
